module.exports = __webpack_public_path__ + "img/close.b1b22ed4.svg";